import { Component } from 'react';
import { routerShape, locationShape } from 'react-router';
import each from 'lodash/each';
import sensor from 'components/sensor';

@sensor
export default class AbstractQueryPage extends Component {
  static propTypes = {
    router: routerShape,
    location: locationShape,
  };

  constructor(props, ctx) {
    super(props, ctx);

    // Page identifier for removing page number from URLs
    this.urlPageId = null;
  }

  /**
   * Update search query, pack it to query string and update an URL
   * @param params
   * @param options - URL generation options:
   *   * removePage -
   */
  updateState(params, options = {}) {
    const { location, router } = this.props;
    const { query: oldQueryString = {} } = location;
    const queryString = { ...oldQueryString };

    let path = location.pathname;
    if (options.removePage) {
      const replRegexp = new RegExp(`\\/${this.urlPageId}\\d+\\/*`);
      path = path.replace(replRegexp, '');
    }

    each(params, (setter, key) => {
      queryString[key] = setter.json ? JSON.stringify(setter.val) : setter.val;
      if (setter.val === null || setter.val === undefined) {
        delete queryString[key];
      }
    });

    const { scrollLeft, scrollTop } = this.sensor.getRuntime();

    router.replace({
      pathname: path,
      query: queryString,
      state: { scrollPosition: [scrollLeft, scrollTop] }
    });
  }
}
